import GenericChartWidget from './GenericChartWidget';

export default GenericChartWidget;
export { GenericChartWidget };
